import { api } from './client'

export interface Holiday {
  date: string // YYYY-MM-DD
  name: string
  is_workday: boolean
}

export async function fetchHolidays(year?: number): Promise<Holiday[]> {
  const r = await api.get<Holiday[]>('/holidays', { params: year ? { year } : {} })
  return r.data
}

export async function createHoliday(body: Holiday): Promise<Holiday> {
  const r = await api.post<Holiday>('/holidays', body)
  return r.data
}

export async function updateHoliday(
  date: string,
  body: { name?: string; is_workday?: boolean },
): Promise<Holiday> {
  const r = await api.patch<Holiday>(`/holidays/${date}`, body)
  return r.data
}

export async function deleteHoliday(date: string): Promise<void> {
  await api.delete(`/holidays/${date}`)
}
